import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const AdminPanel = () => {
  const [news, setNews] = useState([]);
  const [action, setAction] = useState('');
  const [selectedTitle, setSelectedTitle] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const storedNews = JSON.parse(localStorage.getItem('news'));
    if (storedNews) {
      setNews(storedNews);
    }
  }, []);

  const handleActionChange = (e) => {
    setAction(e.target.value);
    setSelectedTitle('');
    setTitle('');
    setDescription('');
    setDate('');
  };

  const handleTitleChange = (e) => {
    setSelectedTitle(e.target.value);
    const selectedNews = news.find(newsItem => newsItem.title === e.target.value);
    if (selectedNews) {
      setTitle(selectedNews.title);
      setDescription(selectedNews.description);
      setDate(selectedNews.date);
    }
  };

  const saveNews = () => {
    let updatedNews;
    if (action === 'edit') {
      updatedNews = news.map(newsItem => newsItem.title === selectedTitle ? { title, description, date } : newsItem);
    } else {
      updatedNews = [...news, { title, description, date }];
    }

    localStorage.setItem('news', JSON.stringify(updatedNews));
    setNews(updatedNews);
    setAction('');
    setSelectedTitle('');
    setTitle('');
    setDescription('');
    setDate('');
  };

  const deleteNews = () => {
    const updatedNews = news.filter(newsItem => newsItem.title !== selectedTitle);

    localStorage.setItem('news', JSON.stringify(updatedNews));
    setNews(updatedNews);
    setAction('');
    setSelectedTitle('');
    setTitle('');
    setDescription('');
    setDate('');
  };

  const makeBold = () => {
    const textarea = document.getElementById('description');
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = textarea.value.substring(start, end);
    const newText = textarea.value.substring(0, start) + `<strong>${selectedText}</strong>` + textarea.value.substring(end);
    setDescription(newText);
    textarea.focus();
    textarea.setSelectionRange(start + 7, end + 7);
  };

  if (!localStorage.getItem('isLoggedIn')) {
    navigate('/');
    return null;
  }

  const containerVariants = {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const inputVariants = {
    focus: { scale: 1.02, transition: { duration: 0.3, ease: 'easeInOut' } },
  };

  const buttonVariants = {
    hover: { scale: 1.05, transition: { duration: 0.3, ease: 'easeInOut' } },
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f4f4f4',
        overflowX: 'hidden',
      }}
    >
      <motion.h2
        style={{
          fontSize: '2.5rem',
          marginBottom: '2rem',
          color: '#007aff',
          fontWeight: 'bold',
        }}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: 'easeInOut' }}
      >
        Админ панель
      </motion.h2>
      <motion.select
        value={action}
        onChange={handleActionChange}
        style={{
          marginBottom: '1rem',
          padding: '1rem',
          borderRadius: '10px',
          border: '1px solid #ccc',
          outline: 'none',
          transition: 'border-color 0.3s ease',
          backgroundColor: '#fff',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
        variants={inputVariants}
        whileFocus="focus"
      >
        <option value="">Выберите действие</option>
        <option value="create">Создать новость</option>
        <option value="edit">Редактировать новость</option>
        <option value="delete">Удалить новость</option>
      </motion.select>

      {action === 'edit' || action === 'delete' ? (
        <motion.select
          value={selectedTitle}
          onChange={handleTitleChange}
          style={{
            marginBottom: '1rem',
            padding: '1rem',
            borderRadius: '10px',
            border: '1px solid #ccc',
            outline: 'none',
            transition: 'border-color 0.3s ease',
            backgroundColor: '#fff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
          variants={inputVariants}
          whileFocus="focus"
        >
          <option value="">Выберите новость</option>
          {news.map(newsItem => (
            <option key={newsItem.title} value={newsItem.title}>{newsItem.title}</option>
          ))}
        </motion.select>
      ) : null}

      {action === 'create' || action === 'edit' ? (
        <div style={{ width: '90%', maxWidth: '500px' }}>
          <motion.input
            type="text"
            placeholder="Заголовок"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            style={{
              marginBottom: '1rem',
              padding: '1rem',
              borderRadius: '10px',
              border: '1px solid #ccc',
              outline: 'none',
              transition: 'border-color 0.3s ease',
              backgroundColor: '#fff',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              minWidth: '500px',
            }}
            variants={inputVariants}
            whileFocus="focus"
          />
          <div style={{ marginBottom: '1rem' }}>
            <motion.button
              onClick={makeBold}
              style={{
                padding: '0.5rem 1rem',
                borderRadius: '10px',
                border: 'none',
                backgroundColor: '#007aff',
                color: '#fff',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                marginRight: '0.5rem',
              }}
              variants={buttonVariants}
              whileHover="hover"
            >
              Жирный
            </motion.button>
          </div>
          <motion.textarea
            id="description"
            placeholder="Описание"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            style={{
              marginBottom: '1rem',
              padding: '1rem',
              borderRadius: '10px',
              border: '1px solid #ccc',
              outline: 'none',
              transition: 'border-color 0.3s ease',
              backgroundColor: '#fff',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              resize: 'vertical',
              minHeight: '100px', // Увеличение высоты textarea
              minWidth: '500px',
            }}
            variants={inputVariants}
            whileFocus="focus"
          />
          <motion.input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
            style={{
              marginBottom: '1rem',
              padding: '1rem',
              borderRadius: '10px',
              border: '1px solid #ccc',
              outline: 'none',
              transition: 'border-color 0.3s ease',
              backgroundColor: '#fff',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            }}
            variants={inputVariants}
            whileFocus="focus"
          />
          <motion.button
            onClick={saveNews}
            style={{
              padding: '1rem',
              borderRadius: '10px',
              border: 'none',
              backgroundColor: '#007aff',
              color: '#fff',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease',
            }}
            variants={buttonVariants}
            whileHover="hover"
          >
            {action === 'create' ? 'Создать' : 'Сохранить'}
          </motion.button>
        </div>
      ) : null}

      {action === 'delete' && selectedTitle ? (
        <motion.button
          onClick={deleteNews}
          style={{
            marginTop: '1rem',
            padding: '1rem',
            borderRadius: '10px',
            border: 'none',
            backgroundColor: '#ff3b30',
            color: '#fff',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
          }}
          variants={buttonVariants}
          whileHover="hover"
        >
          Удалить
        </motion.button>
      ) : null}
    </motion.div>
  );
};

export default AdminPanel;